import { render, staticRenderFns } from "./employeeProfile.vue?vue&type=template&id=4cab3fee&scoped=true"
import script from "./employeeProfile.vue?vue&type=script&lang=js"
export * from "./employeeProfile.vue?vue&type=script&lang=js"
import style0 from "./employeeProfile.vue?vue&type=style&index=0&id=4cab3fee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cab3fee",
  null
  
)

export default component.exports